import {createSelector} from 'reselect';
// selectors
import * as CanvasSelectors from '~/selectors/CanvasSelectors';
import * as ProductSelectors from '~/selectors/ProductSelectors';

export const getDesigns = state => state.design.present;

export const getCurrentDesign = createSelector(
  [getDesigns, CanvasSelectors.getCurrentDesignId],
  (designs, designId) => designs.get(designId)
);

export const getCurrentDesignApiVersion = createSelector(
  [getCurrentDesign],
  design => (design && design.get('apiVersion')) || ''
);

export const getCurrentDesignName = createSelector(
  [getCurrentDesign],
  design => (design && design.get('name')) || ''
);

export const getCurrentDesignIsCombined = createSelector(
  [getCurrentDesign],
  design => (design && design.get('isCombined')) || false
);

export const getCurrentDesignEmail = createSelector(
  [getCurrentDesign],
  design => (design && design.get('email')) || ''
);

export const getCompositeId = createSelector(
  [getCurrentDesign],
  design => design && design.get('compositeId')
);

export const getDesignIdeaId = createSelector(
  [getCurrentDesign],
  design => design && design.get('designIdeaId')
);

export const getDesignCanUpdate = createSelector(
  [getCurrentDesign],
  design => design && design.get('canUpdate')
);

export const getDesignDigest = createSelector(
  [getCurrentDesign],
  design => design && design.get('lastUpdatedAt')
);

export const isFetching = createSelector(
  [getCurrentDesign],
  design => design && design.get('fetching')
);

export const isDirty = createSelector(
  [CanvasSelectors.isDirty, ProductSelectors.isDirty, CanvasSelectors.isBlank],
  (canvasDirty, productDirty, canvasBlank) =>
    (canvasDirty && !canvasBlank) || (productDirty && !canvasBlank)
);

export const getState = createSelector(
  [getCurrentDesign],
  design =>
    design && {
      name: design.get('name'),
      email: design.get('email'),
      compositeId: design.get('compositeId'),
      notes: design.get('notes')
    }
);

export const getInkMatches = createSelector([getCurrentDesign], design =>
  design?.get('inkMatches')?.toJS()
);

export const getInkMatchCount = createSelector(
  [getInkMatches],
  (inkMatches = {}) => Object.keys(inkMatches).length
);
